module.exports = __webpack_public_path__ + "img/icon_order_white.e061280f.svg";